import { defineStore } from 'pinia'
import { MessageAPI } from '@/services/message'
import { ref } from 'vue'
export const useBackgroundStore = defineStore('background', () => {
  const backgroundList = ref<any[]>([])
  const isLoading = ref(false)
  const currentRoleId = ref<number | null>(null)
  const getBackgroundList = async (roleId: number) => {
    // 同一角色有数据时不加载接口
    if (currentRoleId.value === roleId && backgroundList.value.length > 0) return
    currentRoleId.value = roleId
    backgroundList.value = []
    isLoading.value = true
    try {
      const res = await MessageAPI.roleAlbum({
        roleId: roleId
      })
      backgroundList.value = res.data
    } finally {
      isLoading.value = false
    }
  }
  return {
    backgroundList,
    isLoading,
    getBackgroundList
  }
})
